import React from 'react'
import { Icon } from 'types/components'

export const MaterialStartupIcon: Icon = ({ color, size = 24, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 24"
      fill="none"
      width={size}
      height={size}
      {...props}
    >
      <path
        d="M19.4287 18.0033C19.4287 15.014 17.6769 12.4318 15.143 11.2291V6.78808C15.143 6.38361 15.001 5.99254 14.7385 5.68451L10.6564 0.844327C10.4849 0.640755 10.2412 0.53897 10.0001 0.53897C9.75903 0.53897 9.51528 0.640755 9.34386 0.844327L5.26171 5.68451C5.001 5.99317 4.85774 6.38404 4.85725 6.78808V11.2291C2.32332 12.4318 0.571533 15.014 0.571533 18.0033H4.7635C4.70189 18.1961 4.66975 18.405 4.66975 18.6408C4.66975 19.2327 4.87332 19.8113 5.24296 20.2693C5.54468 20.6439 5.94428 20.9276 6.39743 21.089C7.01618 22.5354 8.42243 23.4675 10.0001 23.4675C10.7796 23.4675 11.5349 23.2372 12.1805 22.8033C12.8126 22.38 13.3028 21.7881 13.6001 21.089C14.0531 20.9286 14.4527 20.6458 14.7546 20.272C15.1247 19.8098 15.3268 19.2356 15.3278 18.6434C15.3278 18.4184 15.2983 18.2041 15.2447 18.0059H19.4287V18.0033ZM16.7046 14.9336C16.9564 15.3247 17.1599 15.7452 17.3072 16.1818H15.0358V13.2541C15.7041 13.6903 16.2727 14.2626 16.7046 14.9336ZM6.67868 11.2291V6.82826L10.0001 2.89076L13.3215 6.82826V16.1818H6.67868V11.2291ZM2.69296 16.1818C2.84028 15.7452 3.04386 15.3247 3.29564 14.9336C3.73225 14.2586 4.30011 13.6881 4.96439 13.2541V16.1818H2.69296ZM13.1099 19.2943C12.9706 19.3747 12.8099 19.4068 12.6519 19.3854L12.1296 19.3211L12.0546 19.8408C11.9099 20.8559 11.026 21.622 10.0001 21.622C8.97421 21.622 8.09028 20.8559 7.94564 19.8408L7.87064 19.3184L7.34832 19.3854C7.18953 19.4043 7.02887 19.3714 6.89028 19.2916C6.65725 19.1577 6.51261 18.9086 6.51261 18.6381C6.51261 18.3541 6.67064 18.1184 6.90368 18.0006H13.0992C13.3349 18.1211 13.4903 18.3568 13.4903 18.6381C13.4876 18.9113 13.343 19.1631 13.1099 19.2943ZM8.71439 9.00326C8.71439 9.34425 8.84985 9.67128 9.09097 9.91239C9.33209 10.1535 9.65911 10.289 10.0001 10.289C10.3411 10.289 10.6681 10.1535 10.9092 9.91239C11.1504 9.67128 11.2858 9.34425 11.2858 9.00326C11.2858 8.66226 11.1504 8.33524 10.9092 8.09412C10.6681 7.853 10.3411 7.71754 10.0001 7.71754C9.65911 7.71754 9.33209 7.853 9.09097 8.09412C8.84985 8.33524 8.71439 8.66226 8.71439 9.00326Z"
        fill="url(#paint0_linear_11164_7)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11164_7"
          x1="0.571533"
          y1="0.53897"
          x2="21.7774"
          y2="2.96868"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color ?? '#1753E2'}></stop>
          <stop offset="1" stopColor={color ?? '#F39244'}></stop>
        </linearGradient>
      </defs>
    </svg>
  )
}
